(function ($) {

    let selections = []

    $.fn.cardSelector = function (options) {
        var settings = $.extend({
            counter: "#selected-courses-counter",
            counterData: 'max-courses',
            checkboxes: 'input[type=checkbox]'
        }, options );

        const $checkboxes = this.find(settings.checkboxes)
        const $counter = $(settings.counter)
        const maxSelections = $counter.data(settings.counterData)

        // init with checked
        $checkboxes.filter(':checked').each(function () {
            const card = $(this).closest('.card')[0]
            $(card).addClass('selected')
            selections.push(card)
        })

        $checkboxes.on('change', function () {
            console.log('change', $(this))
            const card = $(this).closest('.card')[0]
            if ($(this).is(':checked')) {
                $(card).addClass('selected')
                selections.push(card)
                if (selections.length > maxSelections) {
                    console.log('max raised: uncheck', $(selections[0]), $(selections[0]).find(settings.checkboxes))
                    $(selections[0]).find(settings.checkboxes).prop( "checked", false ).change()
                }
            } else {
                $(card).removeClass('selected')
                selections = selections.filter((item) => {
                    return card !== item;
                })
            }
            $counter.text(selections.length)
            console.log('selections', selections)
        })

        return this
    }

    $.validator.addMethod("courses", function(value, element, param) {
        return param === selections.length;
	}, 'Seleziona tutti i corsi del coupon');
    $('[data-toggle="card-selector"]').cardSelector().closest('form').validate({
        debug: false,
        ignore: ".ignore",
        errorElement: "div",
        rules: {
            coupon: "required",
            secure_code: {
                required: true,
                minlength: 3
            },
            file: "required",
            "courses[]": {
                courses: parseInt($('#selected-courses-counter').data('max-courses') || '1', 10)
            }
        },
        errorPlacement: function ( error, element ) {
            error.addClass( "text-danger" );
            var $formGroup = element.parents('.form-group');
            if ($formGroup.length === 1) {
                $formGroup.addClass('has-feedback has-error');
                $formGroup.append(error);
            } else if (element.attr("name") === 'courses[]') {
                error.insertAfter( $('[data-toggle="card-selector"]') );
            } else if (element.prop( "type" ) === "checkbox") {
                error.insertAfter( element.parent( "label" ) );
            }
        }
    });

})(jQuery)